import { apiClient, ApiResponse } from './client'

export type AdminRecoveryPurpose = 'find-id' | 'password-reset'

export interface AdminFindIdResult { emails: string[] }
export interface AdminRecoveryAccount { userId: number; email: string }
export interface AdminPasswordResetVerifyResult { resetToken: string; accounts: AdminRecoveryAccount[] }

const base = '/lc/auth/admin-recovery'

export async function requestAdminRecoveryCode(
  purpose: AdminRecoveryPurpose, name: string, phone: string,
): Promise<void> {
  await apiClient.post<ApiResponse<void>>(`${base}/${purpose}/request`, { name, phone })
}

export async function verifyAdminFindId(
  name: string, phone: string, code: string,
): Promise<AdminFindIdResult> {
  const res = await apiClient.post<ApiResponse<AdminFindIdResult>>(
    `${base}/find-id/verify`, { name, phone, code },
  )
  return res.data.data!
}

export async function verifyAdminPasswordReset(
  name: string, phone: string, code: string,
): Promise<AdminPasswordResetVerifyResult> {
  const res = await apiClient.post<ApiResponse<AdminPasswordResetVerifyResult>>(
    `${base}/password-reset/verify`, { name, phone, code },
  )
  return res.data.data!
}

export async function confirmAdminPasswordReset(
  resetToken: string, userId: number, newPassword: string,
): Promise<void> {
  await apiClient.post<ApiResponse<void>>(
    `${base}/password-reset/confirm`, { resetToken, userId, newPassword },
  )
}
